import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';

// Client-side UI gate only. The server action (signInWithPassword) re-validates
// the Turnstile token and owns the actual credential check. Passwords are not
// trimmed. turnstileToken min(1) mirrors the old "Please complete the security
// check." guard: handleSubmit won't fire without a token and the button stays
// disabled until Turnstile succeeds.
export const SignInSchema = z.object({
  email: z
    .string()
    .trim()
    .min(1, 'Email is required')
    .email('Enter a valid email'),
  password: z.string().min(1, 'Password is required'),
  turnstileToken: z.string().min(1, 'Please complete the security check.'),
});

export type SignInValues = z.infer<typeof SignInSchema>;
export const signInResolver = zodResolver(SignInSchema);
